import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";
import { MainDashboard } from "./MainDashboard";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";
import { AppDashboard } from "./AppDashboard";

const Dashboard = Loadable(
  lazy(() =>
    import("./Dashboard/Dashbaord").then(({ Dashboard }) => ({
      default: Dashboard,
    }))
  )
);

export const dashboardRoutes = [
  // {
  //   path: "/dashboard",
  //   exact: true,
  //   element: (
  //     <AuthorizedRoute moduleIds={[ALLOWED_MODULES.DASHBOARD]}>
  //       <Dashboard />
  //     </AuthorizedRoute>
  //   ),
  // },
  {
    path: REACT_APP_NAV_ROUTES.dashboard,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.DASHBOARD]}>
        <AppDashboard />
      </AuthorizedRoute>
    ),
  },
];
